import { useEffect, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { useOutletContext } from "react-router-dom";
import { httpGetRequest } from "./HttpRequestService";
import Pass from "./layout/Pass";

const Passerelle = () => {
    const [token] = useOutletContext();
    const [data, setData] = useState([]);

    const load = async () => {
        try {
            const response = await httpGetRequest(`${token}/myPasserelle`, false);
            if (response.data) setData(response.data);
        } catch (error) {
            console.error(error.response?.data);
        }
    };

    useEffect(() => { load(); }, []);

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <h5 style={{ margin: 0, fontWeight: 700, color: '#1e3a5f' }}>
                    📡 Mes Passerelles ({data.length})
                </h5>
                <Button variant="outline-primary" size="sm" onClick={load}>
                    ↺ Actualiser
                </Button>
            </div>

            {data.length === 0 && (
                <div className="admin-card" style={{ padding: '32px', textAlign: 'center', color: '#6c757d' }}>
                    Aucune passerelle configurée
                </div>
            )}

            {data.map((d, i) => (
                <Card key={i} className="mb-3" style={{ border: '1px solid #dee2e6', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.07)', overflow: 'hidden' }}>
                    <Card.Header style={{ background: '#1e3a5f', padding: '12px 20px' }}>
                        <div className="pass-card-header" style={{ color: '#fff' }}>
                            <span>📡 {d.name}</span>
                            <span style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                background: d.isConnected ? 'rgba(76,175,80,0.2)' : 'rgba(244,67,54,0.2)',
                                padding: '3px 12px',
                                borderRadius: '20px',
                                fontSize: '12px',
                                fontWeight: 600,
                            }}>
                                <span className={`status-dot ${d.isConnected ? 'connected' : 'disconnected'}`}></span>
                                {d.isConnected ? 'Connecté' : 'Déconnecté'}
                            </span>
                        </div>
                    </Card.Header>
                    <Card.Body style={{ padding: '20px' }}>
                        <Pass pass={d} load={load} token={token} />
                    </Card.Body>
                </Card>
            ))}
        </>
    );
};

export default Passerelle;
